import proxy from "api/proxy";
import { getStorage } from "store/local";
import {isValidPhone, isValidName, isValidEmail} from "tools/helpers";


const getAgent = async () => {
  const session = getStorage("ctxSession");
  const dom = [["user", "=", session.user]];
  const fields = ["id", "rec_name"];
  const { data } = await proxy.search("commission.agent", dom, fields, 1);
  return data?.[0];
};

function layout() {
  const ctxView = {
    model: "crm.prospect",
    selectable: "one",
    activeSearch: true,
    form_action: ["edit", "add"],
    table_action: ["add", "edit"],
    orderBy: [["create_date", "DESC"]],
    limit: 30,
    fields: {
      name: {
        type: "char",
        searchable: true,
        required: true,
        uppercase: true,
        validate: ({ value }) => {
          if (!value) return true;
          return isValidName(value)
            ? true
            : "party.party.validation.invalid_name";
        },
      },
      phone: {
        type: "char",
        searchable: true,
        validate: ({ value }) => {
          if (!value) return true;
          return isValidPhone(value)
            ? true
            : "party.party.validation.invalid_phone";
        },
      },
      email: {
        type: "char",
        searchable: true,
        validate: ({ value }) => {
        if (!value) return true;
        return isValidEmail(value)
          ? true
          : "party.party.validation.invalid_email";
      }
      },
      agent: {
        type: "many2one",
        model: "commission.agent",
        default: getAgent,
        searchable: true,
      },
      country: {
        type: "many2one",
        model: "country.country",
        searchable: true,
      },
      company: {
        type: "char",
        model: "Company",
        searchable: true,
      },
      comment: {
        type: "text",
      },
      lead_origin: {
        type: "many2one",
        model: "crm.lead_origin",
        searchable: true,
        required: true,
        filter: true,
      },
      party_category: {
        type: "many2one",
        model: "party.category",
        searchable: true,
        filter: true,
      },
      create_date: {
        type: "date_2",
        filter: true,
      },
    },
    list: [
      { name: "name", width: "30%" },
      { name: "phone", width: "10%" },
      { name: "email", width: "15%" },
      { name: "agent", width: "15%" },
      { name: "country", width: "15%" },
      { name: "company", width: "15%" },
      { name: "lead_origin" },
      { name: "party_category" },
      { name: "create_date", width: "15%", widget: "date" },
    ],
    form: [
      { name: "name" },
      { name: "agent" },
      { name: "phone" },
      { name: "email" },
      { name: "country" },
      { name: "company" },
      { name: "lead_origin" },
      { name: "party_category" },
      {
        name: "comment",
        type: "grid",
        colSpan: "col-span-2",
        elements: [{ name: "comment" }],
      },
    ],
  };
  return ctxView;
}
export { layout };
